import styled from "styled-components";

export const Title = styled.h1`
  font-family: Georgia, 'Times New Roman', Times, serif;
  font-style: normal;
  font-weight: 200;
  text-align: center;
  font-size: 4em;
  margin-top: 0px;
  margin-bottom: 0px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
`;

export const Section = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;

  @media only screen and (min-width: 1080px) {
    width: 1060px;
    max-width: 1060px;
  }
`;